import { render } from "./RolesListTable.vue?vue&type=template&id=2d092b15&scoped=true"
import script from "./RolesListTable.vue?vue&type=script&lang=js"
export * from "./RolesListTable.vue?vue&type=script&lang=js"

import "./RolesListTable.vue?vue&type=style&index=0&id=2d092b15&lang=css"
import "./RolesListTable.vue?vue&type=style&index=1&id=2d092b15&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d092b15"]])

export default __exports__